import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./components/ui/theme-provider";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./contexts/AuthContext";
import { router } from "./routes";
import { CampaignProvider } from "./contexts/CampaignContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

function App() {
	return (
		<ErrorBoundary>
			<ThemeProvider defaultTheme="light" storageKey="ui-theme">
				<AuthProvider>
					<CampaignProvider>
						<RouterProvider router={router} />
						<Toaster />
					</CampaignProvider>
				</AuthProvider>
			</ThemeProvider>
		</ErrorBoundary>
	);
}

export default App;
